import * as Yup from 'yup';

export const brandedAppPromoCodeValidation = Yup.object()
    .shape({
        title: Yup.string().required().max(60).label('Title'),
        code: Yup.string().min(1).required().label('Code'),
        endType: Yup.string().required().label('Promo ends'),
        endDate: Yup.date().when('endType', {
            is: 'date',
            then: Yup.date().nullable().required('End date is required'),
            otherwise: Yup.date().nullable()
        }),
        endAfterOccurrence: Yup.number().when('endType', {
            is: 'occurrence',
            then: Yup.number().min(1).nullable().required().label('End after occurrence'),
            otherwise: Yup.number().min(1).nullable().label('End after occurrence')
        }),
        setupDiscountMethod: Yup.string().nullable().label('Setup discount method'),
        setupDiscountAmount: Yup.number()
            .nullable()
            .when('setupDiscountMethod', {
                is: (val: string) => !!val,
                then: Yup.number()
                    .min(0)
                    .required()
                    .label('Setup discount amount')
                    .when('setupDiscountMethod', {
                        is: 'Percent',
                        then: Yup.number().min(0).max(100).required().label('Setup discount amount')
                    })
            })
            .label('Setup discount amount'),
        subscriptionDiscountMethod: Yup.string().nullable().label('Subscription discount method'),
        subscriptionDiscountAmount: Yup.number()
            .nullable()
            .when('subscriptionDiscountMethod', {
                is: (val: string) => !!val,
                then: Yup.number()
                    .min(0)
                    .required()
                    .label('Subscription discount amount')
                    .when('subscriptionDiscountMethod', {
                        is: 'Percent',
                        then: Yup.number().min(0).max(100).required().label('Subscription discount amount')
                    })
            })
            .label('Subscription discount amount'),
        subscriptionDiscountDuration: Yup.string()
            .nullable()
            .when('subscriptionDiscountMethod', {
                is: (val: string) => !!val,
                then: Yup.string().required().label('Subscription discount duration')
            })
            .label('Subscription discount duration')
    })
    .test('at-least-one-discount', 'At least one discount section (setup or subscription) is required', function (values) {
        if (!values.setupDiscountMethod && !values.subscriptionDiscountMethod) {
            return this.createError({
                path: 'setupDiscountMethod',
                message: 'At least one discount section (setup or subscription) is required'
            });
        }
        return true;
    });
